export default __webpack_public_path__ + "static/media/986.e54dcbb5.jpg";